import { useLayoutEffect, useRef } from "react";

/**
 * A writing surface that grows with its content. overflow-hidden plus a
 * measured height means an inner scrollbar can never appear. Shared by the
 * workbench tools (CNA editor, VBR tool, Copy tool).
 */
export default function AutoGrowTextarea({
  id, value, onChange, placeholder, testId, focusColor = "focus:border-purple-400", invalid = false,
}: {
  id: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  testId?: string;
  focusColor?: string;
  invalid?: boolean;
}) {
  const ref = useRef<HTMLTextAreaElement>(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);
  return (
    <textarea
      ref={ref}
      id={id}
      rows={1}
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      className={`w-full resize-none overflow-hidden bg-transparent text-[15px] leading-relaxed text-gray-900 placeholder:text-gray-300 border-0 border-b ${invalid ? "border-red-300" : "border-gray-100"} focus:outline-none focus:ring-0 py-1.5 transition-colors ${focusColor}`}
      data-testid={testId}
    />
  );
}
